"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default, exports.DURATIONS = void 0;

var _react = _interopRequireDefault(require("react")),
    _utils = require("../utils"),
    DURATIONS = {
  STANDARD: "STANDARD",
  LONGFORM_SHORT: "LONGFORM_SHORT",
  LONGFORM_MEDIUM: "LONGFORM_MEDIUM",
  LONGFORM_LONG: "LONGFORM_LONG"
};

exports.DURATIONS = DURATIONS;

function _default() {
  var icon = "longform";
  return function (_ref) {
    var billingEntityCode = _ref.billingEntityCode,
        addonsCosts = _ref.addonsCosts,
        includedAddons = _ref.includedAddons,
        zeroCost = (0, _utils.getCostForAddon)({
      billingEntityCode: billingEntityCode,
      costs: null
    }),
        shortCost = includedAddons.includes("LONGFORM_SHORT") ? zeroCost : (0, _utils.getCostForAddon)({
      costs: addonsCosts.LONGFORM_SHORT.costs,
      billingEntityCode: billingEntityCode
    }),
        mediumCost = includedAddons.includes("LONGFORM_MEDIUM") ? zeroCost : (0, _utils.getCostForAddon)({
      costs: addonsCosts.LONGFORM_MEDIUM.costs,
      billingEntityCode: billingEntityCode
    }),
        longCost = includedAddons.includes("LONGFORM_LONG") ? zeroCost : (0, _utils.getCostForAddon)({
      costs: addonsCosts.LONGFORM_LONG.costs,
      billingEntityCode: billingEntityCode
    });
    return [{
      label: "STANDARD 1-5min",
      value: DURATIONS.STANDARD,
      suffix: _react["default"].createElement("span", null, zeroCost),
      icon: icon,
      cost: 0
    }, {
      label: "LONGFORM 5-10min",
      value: DURATIONS.LONGFORM_SHORT,
      suffix: _react["default"].createElement("span", null, shortCost),
      icon: icon,
      cost: shortCost
    }, {
      label: "LONGFORM 10-20min",
      value: DURATIONS.LONGFORM_MEDIUM,
      suffix: _react["default"].createElement("span", null, mediumCost),
      icon: icon,
      cost: mediumCost
    }, {
      label: "LONGFORM 20+min",
      value: DURATIONS.LONGFORM_LONG,
      suffix: _react["default"].createElement("span", null, longCost),
      icon: icon,
      cost: longCost
    }];
  };
}